/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import r from"../../../core/Error.js";function e(e,o,s){if(0!==e.error_code)throw new r(o,s,{errorCode:e.error_code,errorMessage:e.error_message})}export{e as checkWasmError};
